export default "__VITE_ASSET__mardakAs__"